import lod_ from "lodash";
import { getMassActionHandler } from "../massActions/getMassActionHandler";

/**
 * Get the conversation actions offered in the mass actions: scope "conversation" and "enableMassAction" set to true
 * @param {Array} actions the actions of the assistantConfig
 * @returns {Array} the actions, sorted by rank
 */
export function getMassConversationActions(actions) {
	const massActions = (actions ?? []).filter(
		action => action?.scope === "conversation" && action?.enableMassAction === true
	);
	return lod_.sortBy(massActions, ["rank"]);
}

/**
 * Check if a conversation respects the filters of a conversation action
 * 	- the channels of the action (valid_for_channel_code)
 * 	- the filter of its mass processing if any (ie the forward with autoSend: one incoming message and no answer)
 * @param {object} action the action of the assistantConfig
 * @param {object} conversation the conversation, with its header and meta counters
 * @returns {boolean}
 */
export function isConversationEligibleForAction(action, conversation) {
	if (
		action?.valid_for_channel_code &&
		!action.valid_for_channel_code.includes(conversation?.header?.channel)
	) {
		return false;
	}
	const handler = getMassActionHandler(action);
	return handler ? handler.isEligible(conversation) : true;
}

/**
 * Get the name of an action in the language of the user, same rule as the conversation actions
 * @param {object} action the action of the assistantConfig
 * @param {string} language the language of the user, ie "FR"
 * @returns {string} the name of the action
 */
export function getActionDisplayName(action, language) {
	if (!lod_.isNil(action?.actionName) && !lod_.isEmpty(action.actionName)) {
		if (!lod_.isNil(language) && !lod_.isNil(action.actionName[language])) {
			return action.actionName[language];
		}
		return action.actionName.EN ?? Object.values(action.actionName)[0] ?? action.name;
	}
	return action?.name;
}
